export enum TaxiCorporationOrderBillingsDownloadRequestBillingType {
  PUB_RAILY_2_TAXI = "PUB_RAILY_2_TAXI",
  PRIV_CARGO_2_TAXI = "PRIV_CARGO_2_TAXI",
  PRIV_TAXI_2_RAILY = "PRIV_TAXI_2_RAILY",
}

export enum TaxiCorporationOrderBillingsDownloadRequestBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export enum TaxiCorporationOrderBillingsDownloadRequestStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPENED = "REOPENED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
}

export enum TaxiCorporationOrderBillingsDownloadRequestOrder {
  DATE_ASC = "DATE_ASC",
  DATE_DESC = "DATE_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
  BILLING_MODEL_ASC = "BILLING_MODEL_ASC",
  BILLING_MODEL_DESC = "BILLING_MODEL_DESC",
  DISTANCE_ASC = "DISTANCE_ASC",
  DISTANCE_DESC = "DISTANCE_DESC",
  DISTANCE_RATE_ASC = "DISTANCE_RATE_ASC",
  DISTANCE_RATE_DESC = "DISTANCE_RATE_DESC",
  DISTANCE_AMOUNT_ASC = "DISTANCE_AMOUNT_ASC",
  DISTANCE_AMOUNT_DESC = "DISTANCE_AMOUNT_DESC",
  HALTING_AMOUNT_ASC = "HALTING_AMOUNT_ASC",
  HALTING_AMOUNT_DESC = "HALTING_AMOUNT_DESC",
  HIGHWAY_CHARGE_ASC = "HIGHWAY_CHARGE_ASC",
  HIGHWAY_CHARGE_DESC = "HIGHWAY_CHARGE_DESC",
  TOTAL_AMOUNT_ASC = "TOTAL_AMOUNT_ASC",
  TOTAL_AMOUNT_DESC = "TOTAL_AMOUNT_DESC",
}

export type TaxiCorporationOrderBillingsDownloadQueryParams = {
  order?: TaxiCorporationOrderBillingsDownloadRequestOrder;
  human_id?: number;
  plan_entry_human_ids?: number;
  date_since?: string;
  date_to?: string;
  cargo_company?: string;
  exclude_cargo_company?: string;
  passenger?: string;
  status?: TaxiCorporationOrderBillingsDownloadRequestStatus;
  billing_model?: TaxiCorporationOrderBillingsDownloadRequestBillingModel;
  billing_type?: TaxiCorporationOrderBillingsDownloadRequestBillingType;
  responsible_taxi?: string;
};

type TaxiCorporationOrderBillingsDownloadRequest = {
  taxiCorporationUuid: string;
  order?: TaxiCorporationOrderBillingsDownloadRequestOrder;
  humanId?: number;
  planEntryHumanIds?: number;
  dateSince?: string;
  dateTo?: string;
  cargoCompany?: string;
  excludeCargoCompany?: string;
  passenger?: string;
  status?: TaxiCorporationOrderBillingsDownloadRequestStatus;
  billingModel?: TaxiCorporationOrderBillingsDownloadRequestBillingModel;
  billingType?: TaxiCorporationOrderBillingsDownloadRequestBillingType;
  responsibleTaxi?: string;
};

export default TaxiCorporationOrderBillingsDownloadRequest;
